import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { actions as baselineTaskActions } from '../../../actions/baselineTaskActions';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import * as types from '../../../constants/actionTypes';
import Notification from '../../../components/Common/Notification';
import Button from '../../Common/Button';
import TextArea from '../../Common/TextArea';
import "./LocationNameForm.scss";

class LocationAttributesForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            searchResults: [],
            selectedResults: [],
            selectedToReceive: [],
            isLoading: false,
            searchParams: {
                term: "",
                isNameSearch: false
            }
        }
    }

    componentDidUpdate = async (prevProps) => {
        if (this.props.projectId && this.props.projectId !== prevProps.projectId) {
            this.searchLocations;
        }
    }

    searchLocations = async () => {
        if (this.props.isProjectsActive === true && this.props.isProjectIdRequiredForLocationTask === false && !this.props.projectId){
            await this.searchLocationsNoProject();
        } else {
            await this.searchLocationsByProject();
        }
    }

    searchLocationsByProject = async () => {
        try {
            this.setState({ isLoading: true });
            const params = {
                term: this.state.searchParams.term,
                isNameSearch: this.state.searchParams.isNameSearch,
                baselineId: this.props.baselineId,
                projectId: this.props.projectId
            }
            const result = await this.props.baselineTaskActions.bulkLocationPushdownSearch(params);
            const payload = result.payload;
            if (result.type === types.SEARCH_BULK_LOCATION_PUSHDOWN_SUCCESS) {
                this.setState({ searchResults: payload.locations });
            } else if (result.type === types.SEARCH_BULK_LOCATION_PUSHDOWN_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    searchLocationsNoProject = async () => {
        try {
            this.setState({ isLoading: true });
            const params = {
                term: this.state.searchParams.term,
                isNameSearch: this.state.searchParams.isNameSearch,
                baselineId: this.props.baselineId,
                baselineTaskIdList: this.props.baselineTaskIds
            };

            const result = await this.props.baselineTaskActions.bulkLocationPushdownSearchNoProject(params);
            const payload = result.payload;
            if (result.type === types.SEARCH_BULK_LOCATION_PUSHDOWN_NO_PROJECT_SUCCESS) {
                this.setState({ searchResults: payload.locations });
                this.props.setSelectedLocations(this.state.searchResults.slice());
            } else if (result.type === types.SEARCH_BULK_LOCATION_PUSHDOWN_NO_PROJECT_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    onChangeSearchBy = () => {
        this.setState({ searchParams: { ...this.state.searchParams, isNameSearch: !this.state.searchParams.isNameSearch } });
    }

    onTermChange = (e) => {
        this.setState({ searchParams: { ...this.state.searchParams, [e.target.name]: e.target.value } });
    }

    onSelectSearchResult = (e) => {
        const options = e.target.options;
        let selected = [];
        for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
                const value = options[i].value;
                const item = this.state.searchResults.find(x => x.id.toString() === value);
                selected.push(item);
            }
        }
        this.setState({ selectedResults: selected });
    }

    onSelectToReceivePushdown = (e) => {
        const options = e.target.options;
        let selected = [];
        for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
                const value = options[i].value;
                const item = this.state.searchResults.find(x => x.id.toString() === value);
                selected.push(item);
            }
        }
        this.setState({ selectedToReceive: selected });
    }

    onAllDown = () => {
        this.props.setSelectedLocations(this.state.searchResults.slice());
    }

    onAllUp = () => {
        this.props.setSelectedLocations([]);
    }

    onSomeDown = () => {
        let toReceivePushdown = this.props.selectedLocations.slice();

        for (let i = 0; i < this.state.selectedResults.length; i++) {
            const option = this.state.selectedResults[i];
            const item = this.props.selectedLocations.find(x => x.id === option.id);
            if (!item) {
                toReceivePushdown.push({ id: option.id, name: option.name });
            }
        }
        this.props.setSelectedLocations(toReceivePushdown);
    }

    onSomeUp = () => {
        let toReceivePushdown = this.props.selectedLocations.slice();
        for (let i = 0; i < this.state.selectedToReceive.length; i++) {
            const option = this.state.selectedToReceive[i];
            const item = this.props.selectedLocations.find(x => x.id === option.id);
            const index = this.props.selectedLocations.indexOf(item);

            toReceivePushdown.splice(index, 1);

        }
        this.props.setSelectedLocations(toReceivePushdown);
    }

    renderResultList = () => {
        let options = [];
        this.state.searchResults.forEach(function (option) {
            options.push(
                <option key={option.id} value={option.id}>{option.name}</option>
            );
        });
        return options;
    }

    renderReceiveList = () => {
        let options = [];
        this.props.selectedLocations.forEach(function (option) {
            options.push(
                <option key={option.id} value={option.id}>{option.name}</option>
            );
        });
        return options;
    }

    render() {

        const searchByText = (this.state.searchParams.isNameSearch) ? "Search by Abbreviations" : "Search By Name";

        return (
            <div>
                <div className="row">
                    <div className="col-12 text-end">
                        <button type="button" className="btn btn-link" onClick={this.onChangeSearchBy}>{searchByText}</button>
                    </div>
                    <div className="col-12">
                        {this.state.searchParams.isNameSearch ?
                            <TextArea rows={5} maxLength={1000} name="term" label="Location Names Start With" type="text" placeholder="Hotel Alpha, Hotel Beta" value={this.state.searchParams.term} onChange={this.onTermChange} />
                        :
                            <TextArea rows={5} maxLength={1000} name="term" label="Location Abbreviations" type="text" placeholder="ABC, XYZ" value={this.state.searchParams.term} onChange={this.onTermChange} />
                        }
                    </div>
                    <div className="col-12 text-end">
                        <div className="input-subtitle">Separate multiple values with comma</div>
                    </div>
                </div>
                <div>
                    <div className="col-12 text-end">
                        <div className="search-button"><Button name="option2-search" text="Search" bootstrapClass="primary" type="button" onClick={this.searchLocations} /></div>
                    </div>
                </div>
                <LoadingIndicator isLoading={this.state.isLoading}>
                    <div className="row">
                        <div className="col-12">
                            <span className="has-float-label">
                                <select id="searchResultsList" className="form-control mt-3" multiple size="8" defaultValue={[]} onChange={this.onSelectSearchResult}>
                                    {this.renderResultList()}
                                </select>
                                <p className="search-results-count">{this.state.searchResults.length} results</p>
                                <label htmlFor="searchResultsList">Search Results</label>
                            </span>
                        </div>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-12 text-center">
                            <Button name="angle-double-down" text="" bootstrapClass="secondary me-4" type="button" onClick={this.onAllDown} iconName="angle-double-down" />
                            <Button name="angle-down" text="" bootstrapClass="secondary me-4" type="button" onClick={this.onSomeDown} iconName="angle-down" />
                            <Button name="angle-up" text="" bootstrapClass="secondary me-4" type="button" onClick={this.onSomeUp} iconName="angle-up" />
                            <Button name="angle-double-up" text="" bootstrapClass="secondary me-4" type="button" onClick={this.onAllUp} iconName="angle-double-up" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <span className="has-float-label">
                                <select id="toReceivePushdownList" className="form-control mt-3" multiple size="8" onChange={this.onSelectToReceivePushdown}>
                                    {this.renderReceiveList()}
                                </select>
                                <label htmlFor="toReceivePushdownList">Locations to Receive Tasks</label>
                            </span>
                        </div>
                    </div>
                </LoadingIndicator>
            </div>
        );
    }
}

LocationAttributesForm.propTypes = {
    baselineTaskActions: PropTypes.object.isRequired,
    setSelectedLocations: PropTypes.func.isRequired,
    selectedLocations: PropTypes.array.isRequired,
    projectId: PropTypes.string,
    baselineId: PropTypes.string.isRequired,
    baselineTaskIds: PropTypes.array.isRequired,
    isProjectsActive: PropTypes.bool.isRequired,
    isProjectIdRequiredForLocationTask: PropTypes.bool.isRequired
};

function mapDispatchToProps(dispatch) {
    return {
        baselineTaskActions: bindActionCreators(baselineTaskActions, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(LocationAttributesForm);
